import { Outlet } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { Plus } from "lucide-react"
import { useGenerateOutlookAuthLinkQuery } from "modules/settings/hooks/outlook/useGenerateOutlookAuthLinkQuery"
import { useTranslation } from "react-i18next"
import { SignatureBanner } from "../../channels/SignatureBanner"
import { OutlookIntegrationsTable } from "./OutlookIntegrationsTable"

export const OutlookConfiguration = () => {
  const { t } = useTranslation()
  const { data, isPending } = useGenerateOutlookAuthLinkQuery()

  return (
    <>
      <div className="flex flex-col gap-6">
        <SignatureBanner />
        <div className="flex flex-col gap-4">
          <div className="flex justify-end w-full">
            <ButtonLink disabled={isPending} href={data?.url}>
              <Plus />
              {t("settings.integrations.outlook.table.addIntegration")}
            </ButtonLink>
          </div>
          <OutlookIntegrationsTable />
        </div>
      </div>
      <Outlet />
    </>
  )
}
